var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgE = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 22.8 29.4",
    width: 22.8,
    height: 29.4,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_2Bc48TDQQa5kvaIXEU2IHARvI4uo70f5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8,
    height: 29.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_2Bc48TDQQa5kvaIXEU2IHARvI4uo70f5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 100.137 14.669 C 100.137 23.186 94.463 29.3 86.119 29.3 C 78.23 29.3 72.364 23.689 72.364 14.669 C 72.364 4.982 79.326 0 86.383 0 C 93.146 0 100.137 4.724 100.137 14.669 Z  M 93.308 14.669 C 93.308 10.603 91.341 5.884 86.23 5.884 C 81.597 5.884 79.156 9.869 79.156 14.669 C 79.156 20.064 82.164 23.456 86.23 23.456 C 91.342 23.456 93.308 18.787 93.308 14.669 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 69.864 26.637 C 68.193 27.755 64.677 29.274 59.884 29.274 C 50.466 29.274 45.813 22.776 45.813 14.837 C 45.812 5.899 52.136 0 60.4 0 C 64.494 0 67.122 0.683 69.451 1.822 L 67.064 7.329 C 65.289 6.586 63.24 6.147 60.812 6.147 C 54.839 6.147 52.812 9.721 52.812 14.655 C 52.812 19.981 55.533 23.434 60.273 23.434 C 61.988 23.434 63.277 23.067 63.674 22.809 L 63.674 17.856 L 58.862 17.856 L 58.87 12.25 L 69.86 12.25 L 69.864 26.637 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 37.695 28.811 C 36.759 25.4 35.194 22.805 33.903 21.146 C 32.814 19.746 31.966 19.446 31.966 19.446 C 31.086 19.47 30.481 19.467 29.674 19.43 L 29.674 28.81 L 23.1 28.81 L 23.1 0.752 C 24.484 0.528 25.477 0.407 26.928 0.273 C 28.267 0.148 29.778 0.067 31.453 0.067 C 33.67 0.067 35.553 0.312 37.099 0.801 C 38.646 1.29 39.909 1.961 40.889 2.812 C 41.894 3.664 42.616 4.72 43.054 5.88 C 43.518 7.014 43.75 8.226 43.75 9.515 C 43.75 11.216 43.334 12.865 42.429 14.275 C 41.625 15.527 40.275 16.809 38.877 17.691 L 38.877 17.815 C 42.001 19.244 43.77 23.845 45.485 28.811 L 37.695 28.811 Z  M 37.154 9.675 C 37.154 8.489 36.728 7.539 35.878 6.895 C 35.027 6.224 33.857 5.896 32.44 5.874 C 32.283 5.872 31.671 5.878 31.304 5.891 C 30.942 5.9 29.977 5.987 29.675 6.042 L 29.675 14.126 C 30.113 14.178 31.023 14.219 31.763 14.219 C 33.335 14.219 34.798 13.786 35.727 13.066 C 36.655 12.317 37.154 11.119 37.154 9.675 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 0 22.093 L 0 0.464 L 19.307 0.464 L 19.312 6.496 L 6.575 6.496 L 6.575 11.349 L 17.354 11.349 L 17.361 17.074 L 6.575 17.074 L 6.575 20.106 C 6.575 22.011 7.694 22.817 9.153 22.817 C 12.114 22.817 19.832 22.816 19.832 22.816 L 19.84 28.81 L 6.668 28.81 C 1.735 28.81 0 26.533 0 22.093 Z ",
    fill: "rgb(255,255,255)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgE);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/e.7163795704b66cfadceb21bd5212a863.svg";